// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import SelMemberDialog from './SelMemberDialog';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';



export default function UserGroupAddDialog(props) {

  const { sysID, open, onClose, afterUpdate, editMode, editGroup } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });
  }


  // Use when "open" changed
  useEffect(async () => {
    // console.log("useEffect DocTypeEditDialog(open)");
    if (open) {
      if (editMode) {
        setValue("name", editGroup.Name);
        setValue("desc", editGroup.Desc);

        setShowLoading(true);

        try {
          setSelectedRecs([]);

          const vMembers = await DmsService.getGroupMembersPromise(gState.sessionID, sysID, editGroup.GroupID);
          // console.log("vMembers", vMembers);

          setShowLoading(false);

          setGridData(vMembers);

        } catch (e) {
          setShowLoading(false);

          setGridData([]);

          // setErrMsg(e.errMsg || e.message);
          // setShowError(true);
          onCatchPromiseError(e);
        }
      } else {
        setValue("name", "");
        setValue("desc", "");

        setGridData([]);
      }


    }

  }, [open])

  const handleCloseClick = () => {
    // initData();

    onClose && onClose();
  }

  // Setup inital form values
  const defaultFormValues = {
    name: "",
    desc: "",
  }

  // React Hook the form
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: defaultFormValues
  });



  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [members, setMembers] = useState([]);

  const handleAddByUser = async () => {

    setShowLoading(true);

    try {

      const vUsers = await DmsService.getMembersPromise(gState.sessionID, sysID, false);

      // console.log('vUsers', vUsers);

      setShowLoading(false);

      setMembers(vUsers);

      setOpenAddUserDialog(true);
    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    }


  };


  const [selectedRecs, setSelectedRecs] = useState([]);
  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();

    let selRecs = nodes.map(item => {
      return item.data
    });

    setSelectedRecs(selRecs);

  }

  const handleSelectAddUsers = (aUsers) => {
    // console.log("aUsers", aUsers);

    setOpenAddUserDialog(false);

    let vData = gridData.map(item => {
      return item
    });

    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.UserID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        const vNewItem = {
          "DeptName": addUser.Department,
          "Desc": addUser.Desc,
          "Name": addUser.FullName,
          "UserID": addUser.UserID,
        }

        vData.push(vNewItem);
      }
    });

    // console.log("vData", vData);
    setGridData(vData);

  }

  const handleRemove = () => {
    // console.log("handleRemove selectedRecs", selectedRecs);

    const vData = gridData.filter(d => !selectedRecs.some(r => r.UserID === d.UserID));
    setGridData(vData);
    setSelectedRecs([]);

  }


  const watchName = watch("name");

  const onSubmit = async data => {
    // console.log("onSubmit", data);

    const vMemberIDs = gridData.map(item => item.UserID);

    // console.log("vMemberIDs", vMemberIDs);

    if (editMode) {
      setShowLoading(true);
      try {
        await DmsService.groupEditPromise(gState.sessionID, sysID, editGroup.GroupID, data.name, data.desc, vMemberIDs);

        setShowLoading(false);

        afterUpdate && afterUpdate();

      } catch (e) {
        setShowLoading(false);

        // setErrMsg(e.errMsg || e.message);
        // setShowError(true);
        onCatchPromiseError(e);

      }
    } else {
      setShowLoading(true);

      try {
        await DmsService.groupAddPromise(gState.sessionID, sysID, data.name, data.desc, vMemberIDs);

        setShowLoading(false);

        afterUpdate && afterUpdate();

      } catch (e) {
        setShowLoading(false);

        // setErrMsg(e.errMsg || e.message);
        // setShowError(true);
        onCatchPromiseError(e);

      }


    }


  }


  const [gridData, setGridData] = useState([]);

  const handleGetRowId = useCallback((params) => params.data.UserID, []);

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorUserID = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.UserID, nodeB.data.UserID)
  }

  const comparatorName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Name, nodeB.data.Name)
  }

  const comparatorDept = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.DeptName, nodeB.data.DeptName)
  }

  const comparatorDesc = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Desc, nodeB.data.Desc)
  }


  const columnDefs = useMemo(() => [
    {
      field: 'UserID', headerName: "UserID", cellStyle: cellStyle, minWidth: 150,
      headerCheckboxSelection: true, checkboxSelection: true, comparator: comparatorUserID,
    },
    { field: 'Name', headerName: "Name", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorName, },
    { field: 'DeptName', headerName: "Department", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorDept, },
    { field: 'Desc', headerName: "Description", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorDesc, },
  ], []);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="md"
      aria-describedby="group-add-dialog-description"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <DialogTitle id="alert-dialog-title">
        {editMode && "Edit User Group"}
        {!editMode && "Add User Group"}
      </DialogTitle>
      <DialogContent>

        <Box sx={{ display: 'flex', flexDirection: 'column' }} component="form" onSubmit={handleSubmit(onSubmit)} >

          <Grid container spacing={1}  >

            <Grid item xs={12}>
              <Controller
                name="name"
                control={control}
                render={({ field }) =>
                  <TextField
                    required
                    autoFocus
                    label="Group Name"
                    variant={"standard"}
                    size="small"
                    fullWidth
                    {...field}

                    InputLabelProps={{ shrink: true, }}
                  />}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="desc"
                control={control}
                render={({ field }) =>
                  <TextField
                    label="Group Description"
                    variant="standard"
                    size="small"
                    fullWidth
                    {...field}

                    InputLabelProps={{ shrink: true, }}
                  />}
              />

            </Grid>
          </Grid>



          <Box sx={{ py: 1, px: 1 }} >
            <Button startIcon={<PersonAddAlt1Icon />} onClick={handleAddByUser} >
              Add
            </Button>
            <SelMemberDialog
              open={openAddUserDialog}
              onClose={() => { setOpenAddUserDialog(false) }}
              members={members}
              onSelect={handleSelectAddUsers}
              disableGroupTab
            />

            <Button startIcon={<PersonRemoveIcon />} disabled={selectedRecs.length == 0} onClick={handleRemove} >
              Remove
            </Button>

          </Box>

          <div className="ag-theme-material" style={{ width: '100%', height: '50vh', }}>
            <AgGridReact

              rowData={gridData}

              defaultColDef={{
                width: 100,
                resizable: true,
                sortable: true,
                suppressMovable: true,
              }}
              columnDefs={columnDefs}
              headerHeight={40}

              suppressNoRowsOverlay

              rowSelection="multiple"
              rowMultiSelectWithClick

              onSelectionChanged={onSelectionChanged}

              getRowId={handleGetRowId}
            />
          </div>




          <Box sx={{ textAlign: 'right', mt: 1 }} >

            <Button onClick={handleCloseClick}>Cancel</Button>
            <Button type="submit" variant="contained" startIcon={<SaveIcon />} disabled={(!watchName || watchName.trim() == "")}  >
              Save
            </Button>
          </Box>

        </Box>
      </DialogContent>
      <DialogActions>

      </DialogActions>
    </Dialog>

  );
}

UserGroupAddDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  afterUpdate: PropTypes.func,
  editMode: PropTypes.bool,
  editGroup: PropTypes.object,
};
